// Anxious modifier: the board scrambles on its own on a random interval.
// Does not mark cards as used — only repositions (and applies Twisted if on).

export const ANXIOUS_MIN_MS = 5000;
export const ANXIOUS_MAX_MS = 15000;
export const ANXIOUS_WARN_MS = 2000;

export function getAnxiousScrambleDelayMs(random = Math.random) {
    const span = ANXIOUS_MAX_MS - ANXIOUS_MIN_MS;
    const roll = typeof random === "function" ? Number(random()) : Math.random();
    const unit = Number.isFinite(roll) ? Math.min(1, Math.max(0, roll)) : 0;
    return ANXIOUS_MIN_MS + Math.round(unit * span);
}

/** True when an Anxious scramble (or pre-scramble warn pulse) must wait.
 *  Shy hide/flip animation must not block — otherwise the warn can be skipped
 *  while the scramble timer still fires (scramble with no pulse). */
export function isAnxiousScrambleBlocked(state = {}) {
    return Boolean(
        state.screen !== "game" ||
            !state.anxiousMode ||
            state.showStoryIntro ||
            state.showResumeOverlay ||
            state.showHeartContinueOverlay ||
            state.showHeartEmptyOverlay ||
            state.showLevelCompleteOverlay ||
            state.showExitConfirm ||
            state.showGuideHeartDemo ||
            state.showShinyDiscovery ||
            state.runPausedAt
    );
}
